<template>

    <v-locale-provider locale="ar">
      <v-app>
        <v-main>
          <router-view/>
        </v-main>
      </v-app>
    </v-locale-provider>

</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&display=swap');
*{
  font-family: 'Cairo';
}
</style>